import React from 'react';
import { Download, Star, Smartphone, Laptop, Monitor, TrendingUp, Play, Award, Users, BarChart4 } from 'lucide-react';
import Screenshot from './screenshot.png';
import Icon from './icon.svg';
import Setup  from './animix-setup.exe';

const AnimixLanding = () => {
  return (
    <>
      {/* Montserrat Font Import */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');
          * {
            font-family: 'Montserrat', sans-serif;
          }
        `}
      </style>

      <div className="min-h-screen bg-gradient-to-br from-purple-950 via-indigo-900 to-gray-900 text-white p-4 md:p-8">
        {/* Header Section */}
        <div className="max-w-4xl mx-auto text-center mb-8 md:mb-12">
          <div className="flex justify-center items-center mb-6">
          <img
                src={Icon}
                alt="Animix Desktop Logo"
                className="h-20 w-30 md:h-16 md:w-160"
              />
              
          </div>
          
          <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-8 bg-clip-text text-transparent bg-gradient-to-r from-purple-300 to-indigo-300">Скачать animix</h1>
          <p className="text-lg md:text-xl font-medium text-gray-300 mb-6 md:mb-8">Пусть аниме станет твоим вторым домом</p>
          
            {/* Features Icons */}
            <div className="hidden md:flex justify-center gap-8 mb-8">
            <div className="flex flex-col items-center">
              <div className="bg-purple-800/30 p-3 rounded-full mb-2">
                <TrendingUp className="h-6 w-6 text-purple-300" />
              </div>
              <span className="text-sm text-gray-300">Популярное</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="bg-purple-800/30 p-3 rounded-full mb-2">
                <Award className="h-6 w-6 text-purple-300" />
              </div>
              <span className="text-sm text-gray-300">4К высокое качество</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="bg-purple-800/30 p-3 rounded-full mb-2">
                <Users className="h-6 w-6 text-purple-300" />
              </div>
              <span className="text-sm text-gray-300">Социальная сеть</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="bg-purple-800/30 p-3 rounded-full mb-2">
                <BarChart4 className="h-6 w-6 text-purple-300" />
              </div>
              <span className="text-sm text-gray-300">Достижения и статистика</span>
            </div>
          </div>
          
          {/* Download Buttons */}
          <div className="flex flex-col items-center mb-8 md:mb-16">
            <div className="flex flex-col md:flex-row justify-center gap-3 md:gap-4 mb-4">
              <a 
                href={Setup}
                download
                className="flex items-center bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 px-5 py-3 rounded-xl transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-purple-500/30 w-full md:w-auto"
              >
                <div className="bg-white/10 p-2 rounded-lg mr-3">
                  <Laptop className="h-5 w-5" />
                </div>
                <div className="text-left">
                  <div className="text-sm font-semibold">Скачать</div>
                  <div className="text-xs text-gray-300">Для Windows, 80 MB</div>
                </div>
              </a>
              
              <a 
                href="https://play.google.com/store/apps/details?id=lol.animix.app" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-600 hover:to-gray-700 px-5 py-3 rounded-xl transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-gray-500/30 w-full md:w-auto"
              >
                <div className="bg-white/10 p-2 rounded-lg mr-3">
                  <Smartphone className="h-5 w-5" />
                </div>
                <div className="text-left">
                  <div className="text-sm font-semibold">Скачать</div>
                  <div className="text-xs text-gray-300">Для Android</div>
                </div>
              </a>

              <a 
                href="https://t.me/animixapps" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-700 hover:to-gray-800 px-5 py-3 rounded-xl transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-gray-500/30 w-full md:w-auto"
              >
                <div className="bg-white/10 p-2 rounded-lg mr-3">
                  <Smartphone className="h-5 w-5" />
                </div>
                <div className="text-left">
                  <div className="text-sm font-semibold">Скачать</div>
                  <div className="text-xs text-gray-300">Для iOS (IPA)</div>
                </div>
              </a>
            </div>
            
            <a 
              href="https://t.me/animixapps" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm mt-4 text-gray-400 hover:text-white transition-colors duration-200"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm5.92 8.12l-1.61 7.58c-.12.56-.45.7-.91.44l-2.53-1.87-1.21 1.17c-.14.14-.25.25-.51.25l.18-2.5 4.58-4.13c.2-.18-.04-.28-.31-.1L8.54 12.5l-2.45-.77c-.53-.17-.54-.53.11-.78l9.56-3.68c.44-.17.84.1.7.85z" />
              </svg>
              Скачать из Telegram
            </a>
          </div>
        </div>

        {/* App Screenshot with decorative elements */}
        <div className="max-w-5xl mx-auto relative">
          {/* Decorative circles */}
          <div className="absolute -top-6 -left-6 w-12 h-12 bg-purple-500/20 rounded-full blur-xl"></div>
          <div className="absolute top-1/4 -right-10 w-24 h-24 bg-indigo-500/20 rounded-full blur-xl"></div>
          <div className="absolute -bottom-10 left-1/3 w-16 h-16 bg-purple-400/20 rounded-full blur-xl"></div>
          
          {/* Screenshot container */}
          <div className="relative bg-gradient-to-r from-purple-600/20 to-indigo-600/20 p-2 md:p-3 rounded-3xl shadow-2xl">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-indigo-500/10 rounded-3xl"></div>
            
            {/* Screenshot */}
            <div className="relative overflow-hidden rounded-2xl shadow-inner w-full">
              <img
                src={Screenshot}
                alt="Animix App Interface"
                className="w-full h-auto rounded-2xl"
              />
              
           
            </div>
          </div>
          
          {/* App badges */}
          <div className="flex justify-center gap-4 mt-8">
            <div className="bg-purple-900/50 px-4 py-2 rounded-full text-sm flex items-center gap-2">
              <Star className="h-4 w-4 text-yellow-400" fill="currentColor" />
              <span>4.3 рейтинг</span>
            </div>
            <div className="bg-purple-900/50 px-4 py-2 rounded-full text-sm flex items-center gap-2">
              <Download className="h-4 w-4 text-green-400" />
              <span>100K+ загрузок</span>
            </div>
          </div>
        </div>
        
        {/* Footer */}
        <footer className="mt-16 text-center text-sm text-gray-500">
          <p>© 2025 Animix. Все права защищены.</p>
        </footer>
      </div>
    </>
  );
};

export default AnimixLanding;